import { billingClient } from '#pplx_generated/typespec/rest/billing/client.js';
export const getAsiAccessDecision = async ({ reason, }) => {
    const { data, error } = await billingClient.GET('/rest/billing/asi-access-decision', reason, {});
    if (error) {
        return null;
    }
    return data ?? null;
};
//# sourceMappingURL=getAsiAccessDecision.js.map